import React, { useEffect, useState } from 'react';

interface TitleModalProps {
  title: string;
  isTitleModalOpen: boolean;
  onSave: (title: string) => void;
  onClose: () => void;
}

const TitleModal: React.FC<TitleModalProps> = ({ title, isTitleModalOpen, onSave, onClose }) => {
  const [newTitle, setNewTitle] = useState(title);

  useEffect(() => {
    if (isTitleModalOpen) {
      setNewTitle(title);
    }
  }, [isTitleModalOpen, title]);

  const handleSaveTitle = () => {
    onSave(newTitle);
    onClose();
  };

  return (
    <div className={`modal ${isTitleModalOpen ? 'block' : 'hidden'}`}>
      <div className="p-3">
        <input
          autoFocus
          type="text"
          value={newTitle}
          maxLength={30}
          onChange={(e) => setNewTitle(e.target.value)}
          className="input-field w-[100%] p-2 text-center"
        />
        <div className="flex justify-center gap-2">
          <button
            onClick={handleSaveTitle}
            className="bg-storyblue text-white font-bold font-sans rounded-2xl px-4 py-2 text-xs mt-4"
          >
            Save
          </button>
          <button
            onClick={onClose}
            className="bg-storyblueSecondLightText text-white font-bold font-sans rounded-2xl px-4 py-2 text-xs mt-4"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default TitleModal;